import {useTranslation} from 'react-i18next';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@chekinapp/ui';
import PageSideBar from 'components/PageSideBar';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

function MobileMenuDrawer({open, onOpenChange}: Props) {
  const {t} = useTranslation();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="w-[82%] max-w-[340px] overflow-hidden rounded-r-[var(--drawer-content-radius)] border-none bg-[var(--sidebar-bg)] p-0 shadow-[18px_0_50px_color-mix(in_srgb,var(--chekin-color-brand-navy)_35%,transparent)] [&>button]:hidden"
      >
        <SheetHeader className="sr-only">
          <SheetTitle>{t('menu', {defaultValue: 'Menu'})}</SheetTitle>
          <SheetDescription>
            {t('navigation', {defaultValue: 'Navigation menu'})}
          </SheetDescription>
        </SheetHeader>
        <PageSideBar closeMobileMenu={() => onOpenChange(false)} />
      </SheetContent>
    </Sheet>
  );
}

export {MobileMenuDrawer};
